module.exports = __webpack_public_path__ + "media/slot-game/pasta-abc23925.svg";